module.exports = __webpack_public_path__ + "static/media/drop-down_cards.d3055531.svg";